import { Box, IconButton, styled, Tooltip } from '@ethings/ui-toolkit';
import { useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSidebarPinContext, useSmallScreen } from '../../hooks';
import { IfFlag } from '../flags';
import { Icon } from '../icons';
import { PortalHeader } from '../sidebar';

interface SideMenuHeaderProps {
  isOpen: boolean;
}

export const SideMenuHeader: FC<SideMenuHeaderProps> = ({ isOpen }) => {
  const smallScreen = useSmallScreen();
  const { isPinned, toggleIsPinned } = useSidebarPinContext();
  const theme = useTheme();
  const { t } = useTranslation(['common']);

  return (
    <div>
      <Box id="custom-sidebar-container">
        <Box id="custom-sidebar-content"></Box>
      </Box>
      <DefaultContainer id="default-sidebar-container" alignItems={smallScreen ? 'center' : 'flex-start'} ml={smallScreen ? 4 : 0}>
        <PortalHeader.Generic collapsed={!isOpen} />
        {smallScreen && <StyledIcon icon="X" />}
        {!smallScreen &&
          <IfFlag flag="portals-pin-sidebar-feature-temporary">
            <Box pt={1} pr={1}>
              <Tooltip title={isPinned ? t('common:label.sidebar.unpin') : t('common:label.sidebar.pin')}>
                <IconButton color="primary" onClick={toggleIsPinned}>
                  <Icon icon="Pin" style={{ color: isPinned ? theme.palette.primary.main : theme.palette.grey[400] }} />
                </IconButton>
              </Tooltip>
            </Box>
          </IfFlag>
        }
      </DefaultContainer>
    </div>
  );
};

const StyledIcon = styled(Icon)(({ theme }) => ({
  marginRight: theme.spacing(2),
  cursor: 'pointer',
}));

const DefaultContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));
